import { isTestEnv } from './is-test-env';

const HOME_URL = 'https://vytenisb.wixsite.com/frameless-tests';
const isInCypress = typeof window !== 'undefined' && window.Cypress;

export const isInWix = () => {
  return isTestEnv || (typeof window !== 'undefined' && window.top !== window.self && !isInCypress);
};

export const isInFramelessCypress =
  typeof window !== 'undefined' && window.location.href.startsWith(HOME_URL);
